import { jsonProperty, Serializable } from 'ts-serializable';

export class SignInDto extends Serializable {
  @jsonProperty(String, null) login: string | null = null;
  @jsonProperty(String, null) password: string | null = null;
}
